module.exports = __webpack_public_path__ + "static/media/accomplish.5c773fc8.png";